import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import RegistrationForm from "@/components/RegistrationForm";
import VehicleRegistrationTable from "@/components/VehicleRegistrationTable";

import { useState } from "react";

interface VehicleRegistrationProps {
  userRole: "staff" | "admin";
  userName: string;
  userId: number;
}

const VehicleRegistration = ({ userRole, userName, userId }: VehicleRegistrationProps) => {
  const [tab, setTab] = useState("form");
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-7xl mx-auto">
        <Tabs value={tab} onValueChange={setTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="form">Vehicle Registration Form</TabsTrigger>
            <TabsTrigger value="table">Vehicle Registrations Table</TabsTrigger>
          </TabsList>

          {/* Vehicle Registration Form */}
          <TabsContent value="form">
            <RegistrationForm setTab={setTab} userRole={userRole} userName={userName} />
          </TabsContent>

          {/* Vehicle Registrations Table Tab */}
          <TabsContent value="table">
            <Card className="shadow-lg">
              <CardHeader>
                <CardTitle>Vehicle Registrations</CardTitle>
                <CardDescription>
                  View, manage, and export vehicle registration records
                </CardDescription>
              </CardHeader>
              <CardContent>
                <VehicleRegistrationTable userRole={userRole} userName={userName} userId={userId} />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default VehicleRegistration;
